export interface Pagination {
  limit: number
  offset: number
}

export const DEFAULT_PAGINATION: Pagination = {
  limit: 10,
  offset: 0,
}
